@if (paymentModel.quickPayType() === PaymentType.GROUP_PAY) {
    <woa-button class="quick-pay-button group-order"
                [label]="showSpinner() ? 'woa.message.order.initiating' : 'woa.button.checkout.payWithGroupOrder'"
                [translationParams]="{'groupOrderName': groupOrderModel.preferredTransferTarget()?.name | possessive}"
                [icon]="'users'" [showSpinner]="showSpinner()"
                [disabled]="disabled() || configurationModel.timeTestMode() || orderModel.orderInitiationStatus() === OrderInitiationStatus.INITIATING"
                (onActivate)="pay.emit(PaymentType.GROUP_PAY)"></woa-button>
} @else if (paymentModel.quickPayType() === PaymentType.SAVED_CREDIT_CARD) {
    <woa-button class="quick-pay-button credit-card"
                [label]="showSpinner() ? 'woa.message.order.initiating' : 'woa.button.checkout.payWithCard'"
                [showSpinner]="showSpinner()"
                [disabled]="disabled() || configurationModel.timeTestMode() || orderModel.orderInitiationStatus() === OrderInitiationStatus.INITIATING"
                (onActivate)="pay.emit(PaymentType.SAVED_CREDIT_CARD)">
        @if (!showSpinner()) {
            <woa-card-brand [brand]="paymentModel.cardBrand()"></woa-card-brand>
        }
        @if (!showSpinner()) {
            <div class="quick-pay-button-card-last-4" slot="after-label">{{ paymentModel.cardLast4() }}</div>
        }
    </woa-button>
} @else if (paymentModel.quickPayType() === PaymentType.APPLE_PAY) {
    <woa-apple-pay-button class="quick-pay-button credit-card apple-pay" [type]="applePayType()"
                          [showSpinner]="showSpinner() || paymentModel.isSubmittingWalletPayment()"
                          [disabled]="disabled() || configurationModel.timeTestMode() || paymentModel.isSubmittingWalletPayment() || orderModel.orderInitiationStatus() === OrderInitiationStatus.INITIATING"
                          (pay)="pay.emit(PaymentType.APPLE_PAY)"></woa-apple-pay-button>
} @else if (paymentModel.quickPayType() === PaymentType.GOOGLE_PAY) {
    <woa-google-pay-button class="quick-pay-button google-pay" [type]="googlePayType()"
                           [showSpinner]="showSpinner() || paymentModel.isSubmittingWalletPayment()"
                           [disabled]="disabled() || configurationModel.timeTestMode() || paymentModel.isSubmittingWalletPayment() || orderModel.orderInitiationStatus() === OrderInitiationStatus.INITIATING"
                           (pay)="pay.emit(PaymentType.GOOGLE_PAY)"></woa-google-pay-button>
}
